import { EcrCodeStatusEnum } from "@/model/data/ecr/EcrCodeStatusEnum";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";

export class GetInstallationsEcrDataReqData implements IFilterInstallations, IPaginationFilter {

    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = null;

    // PaginationFilter
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    machineModels: string[] = null;
    ecrCodeStatus: EcrCodeStatusEnum[] = null;
    ecrCodes: string[] = null;
    sensorModels: string[] = null;
    sensorFirmwares: string[] = null;
    devicesCategories: string[] = null;

}
